import { useAreas } from 'hooks/useAreas'
import { kebabCase } from 'lodash'
import { Link } from 'react-router-dom'

const areaTileColors = [
  'bg-[#B6CFF1]',
  'bg-[#8DE0D5]',
  'bg-[#EBEBFF]',
  'bg-[#A0ABBE]',
  'bg-[#D2F6FF]',
  'bg-[#BBC7D7]',
  'bg-[#9FCDD7]',
  'bg-[#D0E2FA]',
  'bg-[#239687]',
  'bg-[#9FCDD7]',
  'bg-[#8484F6]',
  'bg-[#65C2D7]',
  'bg-[#CFFBF5]',
  'bg-[#BEBEDF]',
  'bg-[#6596D7]',
]

export const DiscoverMore = () => {
  const areas = useAreas()

  return (
    <>
      <section className='text-center md:mt-[100px]'>
        <h2 className='text-[#101828]  text-[40px] font-bold leading-normal tracking-[0.4px] mb-4'>
          Discover more on the law
        </h2>
        <p className='text-[#37455C] text-center text-[18px] font-bold'>
          Practical guidance and resources on everyday law
        </p>
      </section>

      <div className='flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 sm:px-[2%] md:px-[4%] lg:px-[8%]'>
        {areas.map((category, index) => (
          <Link
            to={`/legal-field/${kebabCase(category.master_term)}`}
            state={{
              id: category.id,
            }}
            key={category.id}
            className={`cursor-pointer ${
              areaTileColors[index % areaTileColors.length]
            } rounded-[30px] p-4 flex flex-col items-center justify-center
        w-[45%] sm:w-[30%] md:w-[22%] lg:w-[18%]`}
          >
            <div className='w-full overflow-hidden pb-2'>
              <img
                src={category.image}
                alt={category.master_term}
                className='object-cover rounded-3xl'
              />
            </div>
            <span className='text-sm font-medium mt-1 text-[#101828]'>
              {category.master_term}
            </span>
          </Link>
        ))}
      </div>
    </>
  )
}
